<template>
  <el-select
    v-model="value"
    :multiple="false"
    filterable
    remote
    reserve-keyword
    placeholder="请输入房产"
    :remote-method="remoteMethod"
    @change="change"
    :loading="loading">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "search-house",
  data(){
    return{
      options: [],
      value: [],
      loading: false,
    }
  },
  props:{
    val:{
      type:String|Number,
      default(){
        return ""
      }
    }
  },
  mounted() {

  },
  methods:{
    remoteMethod(query) {
      var that=this;
      ERP.postRequest({url:'admin/CustomerManagement/searchHouse',data:{name:query}},ret=>{
        if(ret.code){
          that.options=ret.data
        }else {

        }
      })
    },
    change(e){
      let obj=this.options.find(ret=>{ return ret.value==e })
      this.$emit("change",obj||{})
    }
  },
  watch:{
    value(n){
      if(n){
        this.change(n)
      }
    },
    val(n){
      this.value=n;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/search-house.vue